import { render, staticRenderFns } from "./CategoryTypeList.vue?vue&type=template&id=1305516d&scoped=true&"
import script from "./CategoryTypeList.vue?vue&type=script&lang=js&"
export * from "./CategoryTypeList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTypeList.vue?vue&type=style&index=0&id=1305516d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305516d",
  null
  
)

export default component.exports